import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
// import logo from '../assets/img/logo.svg';
import logo from "../assets/img/Logo.png";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/nav-icon4.svg';
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
              <Nav.Link href="#eficiencia" className={activeLink === 'eficiencia' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('eficiencia')}>Solução</Nav.Link>
              <Nav.Link href="#beneficios" className={activeLink === 'beneficios' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('beneficios')}>Benefícios</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/company/energiace" target="_blank"><img src={navIcon1} alt="" /></a>
                <a href="https://www.instagram.com/energiace" target="_blank"><img src={navIcon3} alt="" /></a>
                <a href="https://wa.me/5585988651000?text=Ol%C3%A1,%20gostaria%20de%20agendar%20uma%20Consultoria%20Gratuita!" target="_blank"><img src={navIcon4} alt="" /></a>
              </div>
              {/* <HashLink to='#formulario'>
                <button style={{borderRadius: "5px"}} className="vvd"><span>Conectar</span></button>
              </HashLink> */}
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
